import { ContentSaveMoveIcon } from './ContentSaveMoveIcon';

/**
 * author: Michael Richins
 * id FC4F757F-2540-4853-89A3-7FE07FC710C0
 * name content-save-move
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save-move.svg
 * tags
 */
export const FloppyDiscMoveIcon = ContentSaveMoveIcon;
export default FloppyDiscMoveIcon